import React, { Component } from "react";
import CssClasses from "./Transactions.css";
import DatePicker from "react-datepicker";
import DataTable from "../../../Components/DataTable/DataTable";

import { GetTransactions } from "../../../Communication/AdminServicesHandler";

import "react-datepicker/dist/react-datepicker-cssmodules.css";

import { connect } from "react-redux";
import * as StoreActions from "../../../ReduxStore/Actions/ActionIndex";

import * as LocalStorageKeys from "../../../HOCs/Constants/LocalStorageKeys";

let moment = require("moment");

let tableConfig = {
  maxDataHeight: 550
};

let tableHeaders = [
  {
    id: 1,
    caption: "Iznos",
    dataField: "NominalValue",
    dataType: "numeric",
    width: 5,
    hasTotal: false,
    alignment: "L"
  },
  {
    id: 2,
    caption: "Tip",
    dataField: "TransactionTypeFMT",
    dataType: "string",
    width: 5,
    hasTotal: false,
    alignment: "L"
  },
  {
    id: 3,
    caption: "Vrijeme",
    dataField: "TimestampFMT",
    dataType: "datetime",
    width: 15,
    hasTotal: false,
    alignment: "L"
  },
  {
    id: 4,
    caption: "Vrsta",
    dataField: "ValueTypeFMT",
    dataType: "string",
    width: 10,
    hasTotal: false,
    alignment: "L"
  },
  {
    id: 5,
    caption: "Identifikator",
    dataField: "Identifier",
    dataType: "string",
    width: 25,
    hasTotal: false,
    alignment: "L"
  },
  {
    id: 6,
    caption: "Uspješna?",
    dataField: "IsSuccessful",
    dataType: "bool",
    width: 10,
    hasTotal: false,
    alignment: "L"
  },
  {
    id: 7,
    caption: "Potvrđena?",
    dataField: "IsConfirmed",
    dataType: "bool",
    width: 10,
    hasTotal: false,
    alignment: "L"
  },
  {
    id: 8,
    caption: "Poništena?",
    dataField: "IsCancelled",
    dataType: "bool",
    width: 10,
    hasTotal: false,
    alignment: "L"
  }
];

let tableData = [];

class Transactions extends Component {
  state = {
    startDate: new Date(),
    endDate: new Date()
  };

  render() {
    return (
      <div className={CssClasses.container}>
        <div className={CssClasses.row}>&nbsp;</div>
        <div className={CssClasses.row}>
          <div className={CssClasses.colLeft}>Datum od:</div>
          <div className={CssClasses.colRight}>
            <DatePicker
              selected={this.state.startDate}
              onChange={date => {
                this.datePicker_ValueChanged(1, date);
              }}
              dateFormat="dd.MM.yyyy."
            />
          </div>
        </div>
        <div className={CssClasses.row}>
          <div className={CssClasses.colLeft}>Datum do:</div>
          <div className={CssClasses.colRight}>
            <DatePicker
              selected={this.state.endDate}
              onChange={date => {
                this.datePicker_ValueChanged(2, date);
              }}
              dateFormat="dd.MM.yyyy."
            />
          </div>
        </div>
        <div className={CssClasses.row}>
          <div className={CssClasses.colLeft}>&nbsp;</div>
          <div className={CssClasses.colRight}>
            <button
              className={[
                CssClasses.quickPickButton,
                CssClasses.noLeftMargin
              ].join(" ")}
              onClick={() => {
                this.quickPickBtn_Click(1);
              }}
            >
              Danas
            </button>
            <button
              className={CssClasses.quickPickButton}
              onClick={() => {
                this.quickPickBtn_Click(2);
              }}
            >
              Jučer
            </button>
            <button
              className={CssClasses.quickPickButton}
              onClick={() => {
                this.quickPickBtn_Click(3);
              }}
            >
              Ovaj tjedan
            </button>
            <button
              className={CssClasses.quickPickButton}
              onClick={() => {
                this.quickPickBtn_Click(4);
              }}
            >
              Ovaj mjesec
            </button>
            <button
              className={CssClasses.quickPickButton}
              onClick={() => {
                this.quickPickBtn_Click(5);
              }}
            >
              Prošli mjesec
            </button>
          </div>
        </div>
        <div className={CssClasses.separator}>&nbsp;</div>
        <div className={CssClasses.row}>
          <div className={CssClasses.colLeft}>&nbsp;</div>
          <div className={CssClasses.colRight}>
            <button
              className={[CssClasses.loadDataBtn, CssClasses.noLeftMargin].join(
                " "
              )}
              onClick={() => this.btnLoadData_Click()}
            >
              Učitaj
            </button>
          </div>
        </div>
        <div className={CssClasses.separator}>&nbsp;</div>
        <div className={CssClasses.tableContainer}>
          <DataTable
            config={tableConfig}
            headers={tableHeaders}
            data={tableData}
          />
        </div>
      </div>
    );
  }

  btnLoadData_Click() {
    //pali loading
    this.props.changeAdminLoadingIndicator(true);

    GetTransactions(
      this.props.machineInfo.MachineGUID,
      this.state.startDate,
      this.state.endDate,
      this.selectTickets_Callback.bind(this)
    );
  }

  selectTickets_Callback(val) {
    console.log("IN CALLBACK... ", val);

    tableData = val;

    if (tableData) {
      //obradi
      tableData.forEach(el => {
        el.TransactionTypeFMT =
          el.TransactionTypeID === 1
            ? "Uplata"
            : el.TransactionTypeID === 2
            ? "Isplata"
            : el.TransactionTypeID === 3
            ? "Cashout"
            : "Nepoznat [" + el.TransactionTypeID + "]";
        el.TimestampFMT = moment(el.Timestamp).format("DD.MM.YYYY. HH:mm:ss");
        el.ValueTypeFMT = el.IsBill ? "Novčanica" : "Kovanica";
      });
    }

    //console.log("PROPS ", this);

    //gasi loading
    this.props.changeAdminLoadingIndicator(false);
  }

  datePicker_ValueChanged(id, date) {
    if (id === 1) {
      //start date
      this.setState({ startDate: date });
    } else {
      //end date
      this.setState({ endDate: date });
    }
  }

  quickPickBtn_Click(value) {
    var firstday = new Date();
    var lastday = new Date();

    if (value === 1) {
      //danas
    } else if (value === 2) {
      //jucer
      firstday = new Date(firstday.setDate(firstday.getDate() - 1));
      lastday = new Date(lastday.setDate(lastday.getDate() - 1));
    } else if (value === 3) {
      //ovaj tjedan
      firstday = moment()
        .startOf("isoweek")
        .toDate(); //new Date(firstday.setDate(firstday.getDate() - firstday.getDay() - 1));
      lastday = moment()
        .endOf("isoweek")
        .toDate(); // new Date(lastday.setDate(lastday.getDate() - lastday.getDay() + 5));
    } else if (value === 4) {
      //ovaj mjesec
      firstday = new Date(
        firstday.setDate(firstday.getDate() - firstday.getDate() + 1)
      );
      lastday = new Date(lastday.getFullYear(), lastday.getMonth() + 1, 0);
    } else {
      //prosli mjesec
      firstday = new Date(firstday.getFullYear(), firstday.getMonth() - 1, 1); //off by one tako da getmonth vraca prosli
      lastday = new Date(lastday.getFullYear(), lastday.getMonth(), 0);
    }

    console.log("S: " + firstday);
    console.log("E: " + lastday);

    //assign
    this.setState({ startDate: firstday, endDate: lastday });
  }
}

const mapStateToProps = state => {
  return {
    isAdminLoadingShown: state.rrNavigation.isAdminLoadingShown,
    machineInfo: state.rrAppState.machineInfo
  };
};

const mapDispatchToProps = dispatch => {
  return {
    changeAdminLoadingIndicator: isLoading =>
      dispatch(StoreActions.ChangeAdminLoadingIndicator(isLoading))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Transactions);



// WEBPACK FOOTER //
// ./src/Containers/AdminScreens/Transactions/Transactions.js